import { List, Map } from 'immutable'
import { IMenuItem } from 'hooks/useMenu'

const frItems: IMenuItem[] = [
  {
    link: '/fr/publications/all/all',
    items: [],
    title: 'Publications',
    isButton: true
  },
  {
    link: '/fr/actualites/all/all',
    items: [],
    title: 'Actualités',
    isButton: true
  },
  {
    link: '/fr/contact',
    items: [],
    title: 'Contact'
  }
]

const enItems: IMenuItem[] = [
  {
    link: '/en/publications/all/all',
    items: [],
    title: 'Publications',
    isButton: true
  },
  {
    link: '/en/actualites/all/all',
    items: [],
    title: 'Newsroom',
    isButton: true
  },
  {
    link: '/en/contact',
    items: [],
    title: 'Contact us'
  }
]

let localizedMenu = Map<string, List<IMenuItem>>()
localizedMenu = localizedMenu.set('fr', List(frItems))
localizedMenu = localizedMenu.set('en', List(enItems))

export const header = localizedMenu
